export const comments_5187256 = {"data":{"data":[],"links":{}}}